/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ModelObject
 */
export interface ModelObject {
  /**
   *
   * @type {number}
   * @memberof ModelObject
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ModelObject
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof ModelObject
   */
  slug?: string | null
}

/**
 * Check if a given object implements the ModelObject interface.
 */
export function instanceOfModelObject(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function ModelObjectFromJSON(json: any): ModelObject {
  return ModelObjectFromJSONTyped(json, false)
}

export function ModelObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelObject {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ModelObjectToJSON(value?: ModelObject | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
